// Session interaction modes (2026-08-01): classification happens server-side
// per sitting (see logparser.classifySittingMode); this module only renders.

export type SessionMode = 'pairing' | 'steering' | 'autonomous';

export function modeLabel(mode?: string): string | null {
  switch (mode) {
    case 'pairing':
      return 'Pairing';
    case 'steering':
      return 'Steering';
    case 'autonomous':
      return 'Autonomous';
    default:
      return null;
  }
}

// Chip classes per mode: autonomous reads calm (navy), steering hands-on
// (orange), pairing close-contact (emerald).
export function modeChipClass(mode?: string): string {
  switch (mode) {
    case 'autonomous':
      return 'border-navy-200 bg-navy-50 text-navy-700 dark:border-navy-600 dark:bg-navy-800 dark:text-navy-200';
    case 'steering':
      return 'border-orange-200 bg-orange-50 text-orange-700 dark:border-orange-900/40 dark:bg-orange-900/20 dark:text-orange-300';
    case 'pairing':
      return 'border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-900/40 dark:bg-emerald-900/20 dark:text-emerald-300';
    default:
      return 'border-gray-200 bg-gray-50 text-gray-600 dark:border-navy-700 dark:bg-navy-800 dark:text-navy-300';
  }
}

// sincePrompt renders "42m" / "2h30m" / "3d" since the last genuine prompt.
// Returns null when unknown or implausibly stale (the suffix is a LIVE badge;
// a week-old "since prompt" is noise). nowMs is injectable for tests.
export function sincePrompt(lastPromptAtSec?: string, nowMs: number = Date.now()): string | null {
  const sec = parseInt(lastPromptAtSec ?? '0', 10);
  if (!sec) return null;
  const deltaMin = Math.floor((nowMs / 1000 - sec) / 60);
  if (deltaMin < 1 || deltaMin > 24 * 60) return null;
  if (deltaMin < 60) return `${deltaMin}m`;
  const h = Math.floor(deltaMin / 60);
  const m = deltaMin % 60;
  if (deltaMin < 6 * 60) return m > 0 ? `${h}h${m}m` : `${h}h`;
  return `${h}h`;
}
